import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import DragHandleIcon from '@mui/icons-material/DragHandle';
import { CSS } from '@dnd-kit/utilities';
import { TableCell, TableRow, IconButton, Typography } from '@mui/material';
import { KeyboardArrowDown, KeyboardArrowRight } from '@mui/icons-material';
import RCodePartRow from './RCodePartRow/RCodePartRow';
import {
  PARTS_SELECTION_FONT_SIZE,
  TEXT_OVERFLOW_2LINES,
} from '../../../../../_constants/styleConst';
import { OPTION_PARTS_ATTRIBUTES } from '../../../../../_constants/inspectionConst';
import { RCodeInfo } from '../../../PartSelection';
import { tableHeaders } from '../RCodeTable';

// Rコードテーブルの列
type RCodeRowProps = {
  rIndex: number;
  rCode: RCodeInfo;
  isExpanded: boolean;
  isShowOptionParts: boolean;
  toggleAccordion: (index: number) => void;
  onChangeSelection: (
    isChecked: boolean,
    rCode: string,
    listNo: string,
    inFigureNo: string,
  ) => void;
  onChangePartsCode: (
    newPartsCode: string,
    rCode: string,
    listNo: string,
    inFigureNo: string,
  ) => void;
  onChangeAmount: (
    newAmount: string,
    rCode: string,
    listNo: string,
    inFigureNo: string,
  ) => void;
  handlePartsListImage: (isometricDrawing: string, section: string) => void;
};

/** Rコード1つ分 */
const RCodeRow: React.FC<RCodeRowProps> = ({
  rIndex,
  rCode,
  isExpanded,
  isShowOptionParts,
  toggleAccordion,
  onChangeSelection,
  onChangePartsCode,
  onChangeAmount,
  handlePartsListImage,
}) => {
  const { transform, transition, attributes, listeners, setNodeRef } =
    useSortable({ id: rCode.index });

  // 並び替え中のstyle
  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <React.Fragment>
      {/* Rコードを表示する行 */}
      <TableRow {...attributes} ref={setNodeRef} style={style}>
        {/* 並び替えアイコン */}
        <TableCell
          {...listeners}
          sx={{ p: '0.75rem', cursor: 'grab', touchAction: 'none' }}
        >
          <DragHandleIcon />
        </TableCell>
        {/* 開閉アイコン */}
        <TableCell
          sx={{
            p: tableHeaders[1].p,
            width: tableHeaders[1].width,
            textAlign: tableHeaders[1].textAlign,
            fontSize: PARTS_SELECTION_FONT_SIZE,
          }}
        >
          {rCode.partsInfo.length > 0 && (
            <IconButton size="small" onClick={() => toggleAccordion(rIndex)}>
              {isExpanded ? <KeyboardArrowDown /> : <KeyboardArrowRight />}
            </IconButton>
          )}
        </TableCell>
        {/* Rコード */}
        <TableCell
          sx={{
            p: tableHeaders[2].p,
            width: tableHeaders[2].width,
            textAlign: tableHeaders[2].textAlign,
            fontSize: PARTS_SELECTION_FONT_SIZE,
          }}
        >
          {rCode.r.code}
        </TableCell>
        {/* Rコード詳細 */}
        <TableCell
          colSpan={9}
          sx={{
            p: tableHeaders[3].p,
            width: tableHeaders[3].width,
            textAlign: tableHeaders[3].textAlign,
          }}
        >
          <Typography
            sx={{
              ...TEXT_OVERFLOW_2LINES,
              fontSize: PARTS_SELECTION_FONT_SIZE,
            }}
          >
            {rCode.r.detail}
          </Typography>
        </TableCell>
      </TableRow>
      {/* Rコードに紐づくパーツ */}
      {rCode.partsInfo.map((part, partIndex) => (
        <TableRow key={partIndex} style={style}>
          {isExpanded &&
            (isShowOptionParts || // オプションパーツの表示制御
              !OPTION_PARTS_ATTRIBUTES.includes(part.partsAttribute)) && (
              <RCodePartRow
                key={`parts_row_${rCode.r.code}_${partIndex}`}
                index={partIndex}
                rCode={rCode.r.code}
                part={part}
                onChangeSelection={onChangeSelection}
                onChangePartsCode={onChangePartsCode}
                onChangeAmount={onChangeAmount}
                handlePartsListImage={handlePartsListImage}
              />
            )}
        </TableRow>
      ))}
    </React.Fragment>
  );
};

export default RCodeRow;
